// holds all of the type strings for the session action creators



const CHECK_USER = 'session/CHECK_USER';
const LOGIN_USER = 'session/LOGIN_USER';
const LOGOUT_USER = 'session/LOGOUT_USER';
const LOGIN_DEMO = 'session/LOGIN_DEMO';





// exports here
export {
    CHECK_USER,
    LOGIN_USER,
    LOGOUT_USER,
    LOGIN_DEMO,


};
